/* global Period: true  */
import { css } from '@emotion/react'
import { colors } from 'plume-ui'
import { connect } from 'react-redux'
import {
  addCondition,
  changeKeywords,
  resetOffset,
  ConditionName,
  Option,
  OptionSetType,
  PeriodParams,
  RangeParams,
  removeCondition,
  setOptions,
  setPeriod,
  setRange,
  setStatus,
  toggleCondition,
  toggleOption,
  toggleSelector,
} from '../actions'
import {
  openStatusCondition,
  selectFilterFirstInterviewDate,
  selectFilterMyLabel,
  selectFilterSourcingRoute,
  selectFilterStatusCondition,
  selectFilterStatusUpdated,
} from '../actions/statusCondition'
import ConditionList from '../components/condition/ConditionList'
import ConditionSelector from '../components/condition/ConditionSelector'
import { OptionDropdown } from '../../../view/OptionDropdown'
import { OptionDropdownItem } from '../../../view/OptionDropdownItem'
import { State } from '../reducers'
import {
  Conditions,
  FirstInterviewDateCondition,
  StatusConditionItem,
  statusConditionItems,
  StatusUpdatedCondition,
} from '../reducers/condition'
import _ from 'lodash'
import { useUser } from '@/contexts/AuthContext'
import { isLatestEnterpriseOrTrial } from '@/lib/user'
import { formatConditionDisplay } from '../utils'
import { IcomoonIcon } from '../../../atoms/IcomoonIcon'
import { Cover } from '../../../common/Cover'
import PeriodCondition from '../components/condition/PeriodCondition'
import { ConditionTitle } from '../../../view/ConditionTitle'
import { SearchKeywords } from '../components/search-keywords'
import { SourcingRouteCondition } from '../components/conditionItems/sourcingRouteCondition'
import { MyLabelSearchCondition } from '../components/conditionItems/MyLabelSearchCondition'
import { MyLabelId } from '../reducers/sourcingAnnotationCandidates'

const SearchCondition: React.FC<DispatchProps & MapStateProps> = (props) => {
  // @ts-ignore 事実上あっているはずだが、本当はもう少し考えないといけない

  const selected: ConditionName[] = Object.keys(props.conditions)
  const user = useUser()
  const handleOnKeywordChange = (keywords: string) => {
    props.onResetOffset()
    props.onKeywordsChange(keywords)
  }

  const handleSelectOption = (name: ConditionName, value: Option) => {
    props.onResetOffset()
    props.onToggleOption(name, value)
  }

  const handleSelectOptionList = (
    name: ConditionName,
    values: Option[],
    setType: OptionSetType
  ) => {
    props.onResetOffset()
    props.onSetOptions(name, values, setType)
  }

  const handleSetRange = (name: ConditionName, range: RangeParams) => {
    props.onResetOffset()
    props.onSetRange(name, range)
  }

  const handleSetPeriod = (name: ConditionName, period: PeriodParams) => {
    props.onResetOffset()
    props.onSetPeriod(name, period)
  }

  return (
    <>
      <SearchKeywords
        conditionKeywords={props.keywords}
        onChange={handleOnKeywordChange}
        css={css`
          margin-bottom: 16px;
        `}
      />
      <div
        css={css`
          display: grid;
          grid-template-columns: auto 1fr;
          gap: 16px;
        `}
      >
        <ConditionTitle title="企業情報" />
        <div
          className="conditions-row"
          css={css`
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            column-gap: 8px;
            row-gap: 12px;
          `}
        >
          <ConditionList
            conditions={props.conditions}
            opening={props.opening}
            onToggle={props.onToggleCondition}
            onRemove={props.onRemoveCondition}
            onSelectOption={handleSelectOption}
            onSelectRange={handleSetRange}
            onSelectPeriod={handleSetPeriod}
            onSelectOptionList={handleSelectOptionList}
            errors={props.errors}
          />
          <ConditionSelector
            selected={selected}
            open={props.open}
            onToggle={props.onToggleSelector}
            onSelect={props.onAddCondition}
            onRemove={props.onRemoveCondition}
          />
        </div>
        {isLatestEnterpriseOrTrial(user) && (
          <>
            <ConditionTitle title="ステータス" />
            <div
              css={css`
                display: flex;
                align-items: center;
                flex-wrap: wrap;
                column-gap: 8px;
                row-gap: 12px;
              `}
              className={'sourcing-annotations-filter-conditions-row'}
            >
              <div
                css={css`
                  background-color: ${colors.cyan50};
                  border-radius: 50px;
                  color: ${colors.white10};
                  font-size: 13px;
                  position: relative;
                `}
              >
                <li
                  className="condition-label"
                  css={css`
                    display: flex;
                    max-width: 300px;
                    align-items: center;
                    padding: 5px 10px 5px 15px;
                    cursor: pointer;
                  `}
                  onClick={() => {
                    if (
                      props.statusCondition.openingItem ===
                      statusConditionItems.status
                    ) {
                      props.openStatusCondition(null)
                    } else {
                      props.openStatusCondition(statusConditionItems.status)
                    }
                  }}
                >
                  <span
                    css={css`
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      overflow: hidden;
                    `}
                  >
                    ステータス
                    {formatConditionDisplay(
                      props.statusCondition.filterItems,
                      statusConditionItems.status,
                      props.investingStatuses,
                      (ip) => ip.name
                    )}
                  </span>
                  <IcomoonIcon
                    name="arrow8-down"
                    css={css`
                      font-size: 10px;
                      color: ${colors.white10};
                      &:before {
                        font-size: 0.65rem;
                        margin-left: 5px;
                      }
                    `}
                  />
                </li>
                {props.statusCondition.openingItem ===
                  statusConditionItems.status && (
                  <Cover handleClick={() => props.openStatusCondition(null)} />
                )}
                <OptionDropdown
                  open={
                    props.statusCondition.openingItem ===
                    statusConditionItems.status
                  }
                >
                  {props.investingStatuses.map((s, idx) => (
                    <OptionDropdownItem
                      key={idx}
                      condition={_.flatten(
                        props.statusCondition.filterItems
                          .filter(
                            (i) => i.itemName === statusConditionItems.status
                          )
                          .map((i) => i.conditions.map((c) => c.id))
                      ).includes(s.id)}
                      idx={idx}
                      handleSet={() => {
                        props.onResetOffset()
                        props.selectFilterStatusCondition(
                          statusConditionItems.status,
                          {
                            id: s.id,
                          }
                        )
                      }}
                      label={s.name}
                      _css={css`
                        max-width: 320px;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                      `}
                    />
                  ))}
                </OptionDropdown>
              </div>
              <PeriodCondition
                name="statusUpdated"
                open={
                  props.statusCondition.openingItem ===
                  statusConditionItems.statusUpdated
                }
                selected={props.statusCondition.statusUpdated}
                hasError={props.errors.includes('statusUpdated')}
                onToggle={() => {
                  if (
                    props.statusCondition.openingItem ===
                    statusConditionItems.statusUpdated
                  ) {
                    props.openStatusCondition(null)
                  } else {
                    props.openStatusCondition(
                      statusConditionItems.statusUpdated
                    )
                  }
                }}
                onRemove={() => {
                  props.onResetOffset()
                  props.selectFilterStatusUpdated({
                    from: null,
                    to: null,
                  })
                }}
                onSet={(_, period) => {
                  props.onResetOffset()
                  props.selectFilterStatusUpdated({
                    from: period.from ?? null,
                    to: period.to ?? null,
                  })
                }}
              />
              <div
                css={css`
                  background-color: ${colors.cyan50};
                  border-radius: 50px;
                  color: ${colors.white10};
                  font-size: 13px;
                  position: relative;
                `}
              >
                <li
                  className="condition-label"
                  css={css`
                    display: flex;
                    max-width: 300px;
                    align-items: center;
                    padding: 5px 10px 5px 15px;
                    cursor: pointer;
                  `}
                  onClick={() => {
                    if (
                      props.statusCondition.openingItem ===
                      statusConditionItems.contactPeople
                    ) {
                      props.openStatusCondition(null)
                    } else {
                      props.openStatusCondition(
                        statusConditionItems.contactPeople
                      )
                    }
                  }}
                >
                  <span
                    css={css`
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      overflow: hidden;
                    `}
                  >
                    担当者
                    {formatConditionDisplay(
                      props.statusCondition.filterItems,
                      statusConditionItems.contactPeople,
                      props.contactPersonsFilterList,
                      (cp) => `${cp.lastName} ${cp.firstName}`
                    )}
                  </span>
                  <IcomoonIcon
                    name="arrow8-down"
                    css={css`
                      font-size: 10px;
                      color: ${colors.white10};
                      &:before {
                        font-size: 0.65rem;
                        margin-left: 5px;
                      }
                    `}
                  />
                </li>
                {props.statusCondition.openingItem ===
                  statusConditionItems.contactPeople && (
                  <Cover handleClick={() => props.openStatusCondition(null)} />
                )}
                <OptionDropdown
                  open={
                    props.statusCondition.openingItem ===
                    statusConditionItems.contactPeople
                  }
                  _css={css`
                    max-height: 265px;
                    overflow-y: auto;
                  `}
                >
                  {props.contactPersonsFilterList.map((cp, idx) => (
                    <OptionDropdownItem
                      key={idx}
                      condition={_.flatten(
                        props.statusCondition.filterItems
                          .filter(
                            (i) =>
                              i.itemName === statusConditionItems.contactPeople
                          )
                          .map((i) => i.conditions.map((c) => c.id))
                      ).includes(cp.id)}
                      idx={idx}
                      handleSet={() => {
                        props.onResetOffset()
                        props.selectFilterStatusCondition(
                          statusConditionItems.contactPeople,
                          {
                            id: cp.id,
                          }
                        )
                      }}
                      label={`${cp.lastName} ${cp.firstName}`}
                    />
                  ))}
                </OptionDropdown>
              </div>
              <MyLabelSearchCondition
                candidates={props.myLabels}
                selectedMyLabelIds={props.statusCondition.myLabelIds}
                onSelect={props.onSelectMyLabel}
              />
              <PeriodCondition
                name="firstInterviewDate"
                open={
                  props.statusCondition.openingItem ===
                  statusConditionItems.firstInterviewDate
                }
                selected={props.statusCondition.firstInterviewDate}
                hasError={props.errors.includes('firstInterviewDate')}
                onToggle={() => {
                  if (
                    props.statusCondition.openingItem ===
                    statusConditionItems.firstInterviewDate
                  ) {
                    props.openStatusCondition(null)
                  } else {
                    props.openStatusCondition(
                      statusConditionItems.firstInterviewDate
                    )
                  }
                }}
                onRemove={() => {
                  props.onResetOffset()
                  props.selectFilterFirstInterviewDate({
                    from: null,
                    to: null,
                  })
                }}
                onSet={(_, period) => {
                  props.onResetOffset()
                  props.selectFilterFirstInterviewDate({
                    from: period.from ?? null,
                    to: period.to ?? null,
                  })
                }}
              />

              <SourcingRouteCondition
                sourcingRoutes={props.sourcingRoutes}
                sourcingRouteIds={props.statusCondition.sourcingRouteIds}
                onResetOffset={props.onResetOffset}
                onSelectSourcingRoute={props.onSelectSourcingRoute}
              />
            </div>
          </>
        )}
      </div>
    </>
  )
}

SearchCondition.displayName = 'SearchCondition'

type DispatchProps = ReturnType<typeof mapDispatchToProps>
type MapStateProps = ReturnType<typeof mapStateToProps>

const mapStateToProps = (state: State) => ({
  keywords: state.condition.keywords,
  tags: state.condition.tags,
  open: state.app.open,
  conditions: state.condition.selected,
  opening: state.app.openingCondition,
  errors: state.error.errors,
  investingStatuses: state.statuses.data,
  contactPersons: state.contactPersons.data,
  statusCondition: state.statusCondition,
  contactPersonsFilterList: state.contactPersonsFilterList.data,
  sourcingRoutes: state.sourcingAnnotationsCandidates.sourcingRoutes,
  myLabels: state.sourcingAnnotationsCandidates.myLabels,
})

const mapDispatchToProps = (dispatch: any) => ({
  onKeywordsChange: (keywords: string) => {
    dispatch(changeKeywords(keywords))
  },
  onResetOffset: () => {
    dispatch(resetOffset())
  },
  onToggleSelector: () => {
    dispatch(toggleSelector())
  },
  onAddCondition: (name: ConditionName) => {
    dispatch(addCondition(name))
  },
  onRemoveCondition: (name: ConditionName) => {
    dispatch(removeCondition(name))
  },
  onToggleCondition: (name: ConditionName) => {
    dispatch(toggleCondition(name))
  },
  onToggleOption: (name: ConditionName, value: Option) => {
    dispatch(toggleOption(name, value))
  },
  onSetOptions: (
    name: ConditionName,
    values: Option[],
    setType: OptionSetType
  ) => {
    dispatch(setOptions(name, values, setType))
  },
  onSetRange: (name: ConditionName, range: RangeParams) => {
    dispatch(setRange(name, range))
  },
  onSetPeriod: (name: ConditionName, period: PeriodParams) => {
    dispatch(setPeriod(name, period))
  },
  onSelectStatus: (statusId: string) => {
    dispatch(setStatus(statusId))
  },
  openStatusCondition: (item: StatusConditionItem | null) => {
    dispatch(openStatusCondition(item))
  },
  selectFilterStatusCondition: (
    itemName: StatusConditionItem,
    conditions: Conditions
  ) => {
    dispatch(selectFilterStatusCondition({ itemName, conditions }))
  },
  selectFilterStatusUpdated: (payload: StatusUpdatedCondition) => {
    dispatch(selectFilterStatusUpdated(payload))
  },
  selectFilterFirstInterviewDate: (payload: FirstInterviewDateCondition) => {
    dispatch(selectFilterFirstInterviewDate(payload))
  },
  onSelectSourcingRoute: (payload: { id: number }) => {
    dispatch(selectFilterSourcingRoute(payload))
  },
  onSelectMyLabel: (payload: MyLabelId) => {
    dispatch(selectFilterMyLabel(payload))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(SearchCondition)
